import { useEffect, useState } from 'react';
import { ToastStateHandler, UserApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { useTranslation } from '../../useTranslation';

const emptyData = {
    slack: false,
    google: false,
    outlook: false,
    teams: false,
};

const useIntegrationsStatus = () => {
    const { t } = useTranslation('newNotifications');
    const toastHandler = useContainer(ToastStateHandler);
    const userApi = useContainer(UserApi);
    const [isReady, setIsReady] = useState<boolean>(false);
    const [data, setData] = useState(emptyData);

    const getActivatedIntegrations = () => {
        const { exec, abort } = userApi.getIntegrationsStatus({
            onSuccess: res => {
                setData(res.body);
            },
            onError: () => {
                toastHandler.push('error', t('common.error'), t('common.somethingWentWrong'));
            },
            onFinally: () => setIsReady(true),
        });
        exec();
        return abort;
    };
    useEffect(() => {
        getActivatedIntegrations();
    }, []);

    return { data, isReady };
};

export default useIntegrationsStatus;
